import { useMutation, useQueryClient } from '@tanstack/react-query';

import { enableExpertMutation as enableExpertMutationFn } from '../api/mutations/enableExpertMutation';
import { graphQLClient } from '@/client/services/api/clients/graphqlClient';
import { useToastStore } from '@/client/services/state/toastStore';
import { useTranslation } from 'react-i18next';

export const useEnableExpert = () => {
  const { t } = useTranslation();
  const { setToast } = useToastStore();

  const queryClient = useQueryClient();

  const enableExpertMutation = useMutation({
    mutationFn: async (expertId: string) => {
      const data = await graphQLClient.request(enableExpertMutationFn, { expertId });

      return data.enableExpert;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['listExperts'] });

      setToast({
        show: true,
        status: 'success',
        title: t('admin.aiAgent.experts.enableSuccess'),
      });
    },
    onError: () =>
      setToast({
        show: true,
        status: 'error',
        title: t('admin.aiAgent.experts.enableError'),
      }),
  });

  return {
    enableExpertMutation,
  };
};
